<template>
	<router-view />
</template>

<style>
@import './assets/styles/global.css';
</style>
